import type { LoadedSource, SourceConnectionStatus } from './types.ts'
import { isSourceUsable } from './storage.ts'

export function deriveSourceConnectionStatus(
  source: Pick<LoadedSource, 'config'>,
  localMcpEnabled = true
): SourceConnectionStatus {
  const mcp = source.config.mcp
  if (mcp?.transport === 'stdio' && !localMcpEnabled) {
    return 'local_disabled'
  }

  // If credentials are already usable, prefer the live usable state over the
  // stale "untested" marker left behind after saving credentials.
  if (source.config.connectionStatus === 'untested' && isSourceUsable(source as LoadedSource)) {
    return 'connected'
  }

  if (source.config.connectionStatus) {
    return source.config.connectionStatus
  }

  const api = source.config.api
  const requiresAuth = (mcp?.authType && mcp.authType !== 'none') ||
    (api?.authType && api.authType !== 'none')

  if (requiresAuth && !isSourceUsable(source as LoadedSource)) {
    return 'needs_auth'
  }

  if (isSourceUsable(source as LoadedSource)) {
    return 'connected'
  }

  if (source.config.type === 'local' || source.config.type === 'knowledge') {
    return 'connected'
  }

  return 'untested'
}
